import { useEffect, useMemo, useState, useCallback } from 'react';
import './ProgramPages.css';
import { API_BASE } from './config';
import programHero1 from './assets/KiddyActivity.jpg';
import programHero2 from './assets/KGActivity.jpg';
import programHero3 from './assets/PrimaryActivity.jpg';
import programLevel1 from './assets/ProgramKiddy.jpg';
import programLevel2 from './assets/ProgramKG.jpg';
import programLevel3 from './assets/ProgramPrimary.jpg';
import programLevel4 from './assets/ProgramSecondary.jpg';
import epCurriculumKiddy from './assets/EPCurriculumKiddy.jpg';
import epCurriculumKG from './assets/EPCurriculumKG.jpg';
import epCurriculumPrimary from './assets/EPCurriculumPrimary.jpg';
import epCurriculumSecondary from './assets/EPCurriculumSecondary.jpg';
import epSubjectEnglish from './assets/EPSubjectEnglish.jpg';
import epSubjectMathematics from './assets/EPSubjectMathematics.png';
import epSubjectHumanities from './assets/EPSubjectHumanities.png';
import epSubjectPhysicalEducation from './assets/EPSubjectPhysicalEducation.png';
import epSubjectCharacterBuilding from './assets/EPSubjectCharacterBuilding.png';
import epSubjectArts from './assets/EPSubjectArts.png';
import epStrategyIBL from './assets/EPStrategyIBL.jpg';
import epStrategyPBL from './assets/EPStrategyPBL.jpg';
import epStrategyPrBL from './assets/EPStrategyPrBL.jpg';
import epSpecialBridging from './assets/EPSpecialBridging.jpg';
import epSpecialClubs from './assets/EPSpecialClubs.jpg';
import epSpecialLeadership from './assets/EPSpecialLeadership.png';
import epSpecialCommunity from './assets/EPSpecialCommunity.jpg';
import epSpecialECA from './assets/EPSpecialECA.jpg';
import epSpecialTalent from './assets/EPSpecialTalent.jpg';
import { EDUCATION_DEFAULTS } from './data/educationDefaults';

const API_ORIGIN = (process.env.REACT_APP_API_BASE || 'http://localhost/permataharapan-api/api').replace('/api', '');

// Fallback images for various sections
const FALLBACK_IMAGES = [programHero1, programHero2, programHero3];
const CURRICULUM_IMAGES = [epCurriculumKiddy, epCurriculumKG, epCurriculumPrimary, epCurriculumSecondary];
const SUBJECT_IMAGES = {
  'English': epSubjectEnglish,
  'Math': epSubjectMathematics,
  'Science': epSubjectArts,
  'Humanities': epSubjectHumanities,
  'PE': epSubjectPhysicalEducation,
  'Character Building': epSubjectCharacterBuilding,
};

const SPECIAL_PROGRAMS_IMAGES = [
  epSpecialBridging,
  epSpecialClubs,
  epSpecialLeadership,
  epSpecialCommunity,
  epSpecialECA,
  epSpecialTalent,
];

const resolveMediaUrl = (url, fallback) => {
  if (!url) return fallback;
  if (url.startsWith('http') || url.startsWith('blob:') || url.startsWith('data:')) return url;
  if (url.startsWith('/')) return `${API_ORIGIN}${url}`;
  return url;
};

// Icon Components
const AssessmentIcons = {
  chart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="2" x2="12" y2="22" />
      <path d="M17 5H9.5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5H17" />
      <path d="M6 12h3v8H6z" />
      <path d="M9 8h3v12H9z" />
      <path d="M12 5h3v15h-3z" />
      <path d="M15 9h3v11h-3z" />
    </svg>
  ),
  clipboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <path d="M9 14h6" />
      <path d="M9 10h6" />
    </svg>
  ),
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="9" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  trending: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  book: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  lightbulb: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  zap: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1">
      <polygon points="12 2 15.09 10.26 24 10.26 17.55 16.52 19.64 24.78 12 18.52 4.36 24.78 6.45 16.52 0 10.26 8.91 10.26" />
    </svg>
  ),
  award: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="8" r="7" />
      <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88" />
    </svg>
  ),
};

const getAssessmentIcon = (iconType) => {
  return AssessmentIcons[iconType] || AssessmentIcons.chart;
};

function EducationProgramPage({ page, onNavigate }) {
  // Hero slides — fetch from CMS like AboutUsPage
  const [cmsData, setCmsData] = useState(null);
  const [mediaMap, setMediaMap] = useState({});
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  // Fetch media map (like AboutUsPage does)
  const fetchMediaMap = useCallback(async () => {
    try {
      console.log('[EducationProgramPage] Fetching media map...');
      const response = await fetch(`${API_BASE}/education/cms/media?_t=${Date.now()}`, {
        credentials: 'include',
        headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
      });
      
      if (!response.ok) {
        console.warn('[EducationProgramPage] Media fetch failed:', response.status);
        setMediaLoaded(true);
        return;
      }
      
      const result = await response.json();
      
      if (result.ok && Array.isArray(result.data)) {
        const map = {};
        result.data.forEach((media) => {
          const mediaId = media.id || media.media_id;
          const mediaUrl = media.url || media.file_path;
          
          if (mediaId && mediaUrl) {
            map[mediaId] = mediaUrl;
            map[String(mediaId)] = mediaUrl;
          }
        });
        
        console.log('[EducationProgramPage] ✓ Media map ready:', Object.keys(map).length, 'items');
        setMediaMap(map);
      }
    } catch (err) {
      console.error('[EducationProgramPage] Media fetch error:', err.message);
    } finally {
      setMediaLoaded(true);
    }
  }, []);

  // Fetch CMS sections
  const fetchCMSSections = useCallback(async () => {
    try {
      console.log('[EducationProgramPage] Fetching CMS sections...');
      const response = await fetch(`${API_BASE}/education/cms/sections?published=true&_t=${Date.now()}`, {
        credentials: 'include',
        headers: { 
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
      
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      
      const result = await response.json();
      if (result.ok && Array.isArray(result.data)) {
        console.log('[EducationProgramPage] ✓ Sections loaded:', result.data.length, 'sections');
        setCmsData(result.data);
      }
    } catch (err) {
      console.error('[EducationProgramPage] CMS fetch error:', err);
    } finally {
      setDataLoaded(true);
    }
  }, []);

  // Fetch both on mount - PARALLEL
  useEffect(() => {
    console.log('[EducationProgramPage] 🚀 Mount - fetching media and CMS data...');
    fetchMediaMap();
    fetchCMSSections();
  }, [fetchMediaMap, fetchCMSSections]);

  // Extract hero section from CMS
  const heroSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) {
      console.log('[EducationProgramPage] ⚠ heroSection: cmsData is empty');
      return {};
    }
    
    const section = cmsData.find(s => s.section_type === 'education-program-hero');
    if (!section) {
      console.log('[EducationProgramPage] ⚠ heroSection: education-program-hero not found');
      return {};
    }
    
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        console.error('[EducationProgramPage] ✗ Failed to parse hero content_published:', e);
        return {};
      }
    }
    
    const enData = published?.en || {};
    console.log('[EducationProgramPage] ✅ Final heroSection.en:', { title: enData.title, slidesCount: enData.slides?.length || 0 });
    return enData;
  }, [cmsData]);

  // Get hero slides from CMS - resolve image IDs through mediaMap
  // ONLY compute after BOTH media and CMS data have loaded
  const cmsHeroSlides = (mediaLoaded && dataLoaded) ? (heroSection?.slides || []) : [];
  
  // CRITICAL: Resolve image IDs ONLY - no fallbacks to hardcoded images
  const heroSlides = cmsHeroSlides.length > 0
    ? cmsHeroSlides
        .map(slide => mediaMap[slide.image] || mediaMap[slide.media_id])
        .filter(url => url !== null && url !== undefined && url !== '')
    : [programHero1, programHero2, programHero3]; // Fallback only if no CMS data

  const heroTitle = heroSection?.title || EDUCATION_DEFAULTS.title;
  const heroSummary = heroSection?.summary || EDUCATION_DEFAULTS.summary;

  useEffect(() => {
    if (heroSlides.length === 0) return;
    
    const intervalId = setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(intervalId);
  }, [heroSlides.length]);

  useEffect(() => {
    // Wait for CMS data to load before setting up animations
    // This ensures DOM is fully rendered with all items
    if (!dataLoaded || !mediaLoaded) {
      return;
    }

    // Add small delay to ensure DOM is fully rendered after data load
    const timer = setTimeout(() => {
      const animatedItems = document.querySelectorAll('.edu-animate');
      if (!animatedItems.length) {
        console.log('[EducationProgramPage] Animation setup - no animated items found');
        return;
      }

      console.log('[EducationProgramPage] Animation setup - found', animatedItems.length, 'animated items');

      // Force add is-visible to all items immediately to show them
      animatedItems.forEach((item, idx) => {
        item.classList.add('is-visible');
        console.log(`[EducationProgramPage] Card ${idx + 1} - added is-visible class`);
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '50px' }
      );

      animatedItems.forEach((item) => observer.observe(item));
    }, 100);

    return () => clearTimeout(timer);
  }, [dataLoaded, mediaLoaded]);

  // ── Program levels — fetch from CMS like Hero section ──────────────────────────────────────────────────────────
  // Extract levels section from CMS
  const levelsSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) {
      console.log('[EducationProgramPage] ⚠ levelsSection: cmsData is empty');
      return {};
    }
    
    const section = cmsData.find(s => s.section_type === 'education-program-levels-shell');
    if (!section) {
      console.log('[EducationProgramPage] ⚠ levelsSection: education-program-levels-shell not found');
      return {};
    }
    
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        console.error('[EducationProgramPage] ✗ Failed to parse levels content_published:', e);
        return {};
      }
    }
    
    const enData = published?.en || {};
    console.log('[EducationProgramPage] ✅ Final levelsSection.en:', { levelsCount: enData.levels?.length || 0 });
    return enData;
  }, [cmsData]);

  // CRITICAL: Resolve level image IDs through mediaMap ONLY - no fallbacks to hardcoded images
  const programLevels = (levelsSection?.levels || []).map(level => {
    let resolvedLevel = { ...level };
    
    // Resolve image ID to URL if available
    if (level.image && mediaMap[level.image]) {
      resolvedLevel.image_url = mediaMap[level.image];
    } else if (level.image) {
      // Image ID exists but not in mediaMap - will use fallback later
      resolvedLevel.image_url = null;
    }
    
    return resolvedLevel;
  });

  // Fallback to hardcoded only if NO CMS data
  const displayedLevels = programLevels.length > 0 
    ? programLevels.map((level, i) => ({
        ...level,
        // Use CMS image URL, or fallback if not found, or hardcoded as last resort
        image_url: level.image_url || [programLevel1, programLevel2, programLevel3, programLevel4][i] || programLevel4,
      }))
    : (page?.program_levels || EDUCATION_DEFAULTS.program_levels).map((level, i) => ({
        ...level,
        image_url: [programLevel1, programLevel2, programLevel3, programLevel4][i] || programLevel4,
      }));

  // SAFETY: Ensure we always have 4 levels (prevent card 4 disappearing)
  const safeDisplayedLevels = displayedLevels.length < 4 
    ? [
        ...displayedLevels,
        ...(EDUCATION_DEFAULTS.program_levels.slice(displayedLevels.length) || []).map((level, i) => ({
          ...level,
          image_url: [programLevel1, programLevel2, programLevel3, programLevel4][displayedLevels.length + i] || programLevel4,
        }))
      ]
    : displayedLevels;

  // Debug logging
  console.log('[EducationProgramPage] Program Levels Summary:', {
    cmsLevelsCount: levelsSection?.levels?.length || 0,
    displayedLevelsCount: displayedLevels.length,
    safeDisplayedLevelsCount: safeDisplayedLevels.length,
    levels: safeDisplayedLevels.map(l => ({ title: l.title, hasImage: !!l.image_url }))
  });

  // ── Curriculum overview — fetch from CMS ────────────────────────────
  // Extract curriculum overview section from CMS
  const curriculumOverviewSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) {
      console.log('[EducationProgramPage] ⚠ curriculumOverviewSection: cmsData is empty');
      return {};
    }
    
    const section = cmsData.find(s => s.section_type === 'education-curriculum-overview-shell');
    if (!section) {
      console.log('[EducationProgramPage] ⚠ curriculumOverviewSection: education-curriculum-overview-shell not found');
      return {};
    }
    
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        console.error('[EducationProgramPage] ✗ Failed to parse curriculum content_published:', e);
        return {};
      }
    }
    
    const enData = published?.en || {};
    console.log('[EducationProgramPage] ✅ Final curriculumOverviewSection.en:', { 
      title: enData.title,
      pillarsCount: enData.pillars?.length || 0,
      tracksCount: enData.tracks?.length || 0 
    });
    return enData;
  }, [cmsData]);

  // Build curriculum overview with fallbacks
  // CRITICAL: Resolve track image IDs through mediaMap ONLY - no fallbacks to hardcoded images
  const curriculumTracks = (curriculumOverviewSection?.tracks || []).map(track => {
    let resolvedTrack = { ...track };
    
    // Resolve image ID to URL if available
    if (track.image && mediaMap[track.image]) {
      resolvedTrack.image_url = mediaMap[track.image];
    } else if (track.image) {
      // Image ID exists but not in mediaMap - will use fallback later
      resolvedTrack.image_url = null;
    }
    
    return resolvedTrack;
  });

  const curriculumOverview = {
    title: curriculumOverviewSection?.title || 'National & International Curriculum Pathway',
    summary: curriculumOverviewSection?.summary || 'We blend the national curriculum with Cambridge perspectives so every student grows in faith, character, and academic readiness from Preschool to Secondary.',
    pillars: (curriculumOverviewSection?.pillars || [
      {
        title: 'NATIONAL FOUNDATIONS',
        description: 'Strong alignment with local standards, values education, and Bahasa Indonesia literacy.',
      },
      {
        title: 'CAMBRIDGE PERSPECTIVE',
        description: 'Inquiry, language mastery, and global awareness woven across core subjects.',
      },
      {
        title: 'HOLISTIC GROWTH (SDP)',
        description: 'Co- and extra-curricular programs nurture leadership, service, and life skills.',
      },
    ]),
    tracks: curriculumTracks.length > 0 
      ? curriculumTracks.map((track, i) => ({
          ...track,
          // Use CMS image URL, or fallback if not found, or hardcoded as last resort
          image: track.image_url || [epCurriculumKiddy, epCurriculumKG, epCurriculumPrimary, epCurriculumSecondary][i] || epCurriculumSecondary,
        }))
      : [
          {
            title: 'Preschool',
            subtitle: 'Preschool',
            description: 'Photo of Kiddy students and their activity',
            highlights: [
              'Play-based learning that builds foundational skills',
              'Social-emotional development and early literacy',
              'Creative exploration and motor skill development',
            ],
            image: CURRICULUM_IMAGES[0],
          },
          {
            title: 'Kindergarten',
            subtitle: 'Kindergarten',
            description: 'Photo of KG students and their activity',
            highlights: [
              'Structured play and guided discovery',
              'Phonics, numeracy, and social skills',
              'Transition to formal learning readiness',
            ],
            image: CURRICULUM_IMAGES[1],
          },
          {
            title: 'Primary',
            subtitle: 'Primary',
            description: 'Photo of Primary students and their activity',
            highlights: [
              'Strong foundations in literacy and numeracy',
              'Integrated subject learning and project-based activities',
              'Character Shaping Program introduction',
            ],
            image: CURRICULUM_IMAGES[2],
          },
          {
            title: 'Secondary',
            subtitle: 'Secondary',
            description: 'Permata Harapan Secondary\'s curriculum consists of three interconnected components — the Intra Curriculum (Kurikulum Intl), the Extra Curriculum (ECA), and the Co-Curriculum (CCA).',
            highlights: [
              'Intra Curriculum serves as the core academic programme, providing students with the foundational knowledge and skills essential to their formal education.',
              'The Co-Curriculum (CCA) complements academic learning by providing structured activities that develop skills, values, and competencies aligned with the curriculum.',
              'The Extra Curriculum (ECA) offers additional opportunities for enrichment, allowing students to explore interests, talents, and personal development beyond formal requirements.',
              'Together, Co-Curriculum and Extra Curriculum support the Students Development Program (SDP), which serves as the platform for developing well-rounded students.',
            ],
            image: CURRICULUM_IMAGES[3],
          },
        ],
    note: curriculumOverviewSection?.note || 'Each level is designed to build upon previous learning while preparing students for the next stage of their educational journey.',
  };

  // Debug logging
  console.log('[EducationProgramPage] Curriculum Overview Summary:', {
    cmsTracks: curriculumTracks.length,
    displayedTracks: curriculumOverview.tracks.length,
    tracks: curriculumOverview.tracks.map(t => ({ title: t.title, hasImage: !!t.image }))
  });

  // DEBUG: Log pillars in detail
  console.log('[EducationProgramPage] 🔍 PILLARS DETAILED DEBUG:', {
    pillarCount: curriculumOverview.pillars?.length || 0,
    pillars: curriculumOverview.pillars?.map((p, i) => `[${i}] ${p.title} - ${p.description?.substring(0, 40)}...`),
    firstPillar: curriculumOverview.pillars?.[0],
    secondPillar: curriculumOverview.pillars?.[1],
    thirdPillar: curriculumOverview.pillars?.[2],
    cmsSourcePillars: curriculumOverviewSection?.pillars?.length || 0,
  });

  // ── Build page object from CMS sections ─────────────────────────────────────
  const subjectsSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) {
      console.warn('[EducationProgramPage] subjectsSection: cmsData empty or null');
      return null;
    }
    
    // Try with -shell suffix first, then without
    let section = cmsData.find(s => s.section_type === 'education-subjects-offered-shell');
    if (!section) {
      section = cmsData.find(s => s.section_type === 'education-subjects-offered');
    }
    
    if (!section) {
      console.warn('[EducationProgramPage] ⚠️  subjects section not found. Available types:', cmsData.map(s => s.section_type));
      return null;
    }
    
    console.log('[EducationProgramPage] ✓ Found subjects section:', section.section_type, 'ID:', section.id);
    
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        console.error('[EducationProgramPage] ✗ Failed to parse subjects content_published:', e);
        return null;
      }
    }
    
    const result = published?.en || null;
    if (result) {
      console.log('[EducationProgramPage] ✅ Loaded subjects section data. Subjects count:', result.subjects?.length || 0, 'Stats:', result.stats);
    } else {
      console.warn('[EducationProgramPage] ⚠️  published.en is null/empty. published keys:', Object.keys(published || {}));
    }
    
    return result;
  }, [cmsData]);

  const assessmentSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    // Try with -shell suffix first, then without
    let section = cmsData.find(s => s.section_type === 'education-assessment-system-shell');
    if (!section) {
      section = cmsData.find(s => s.section_type === 'education-assessment-system');
    }
    if (!section) return null;
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        return null;
      }
    }
    return published?.en || null;
  }, [cmsData]);

  const specialProgramsSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    // Try with -shell suffix first, then without
    let section = cmsData.find(s => s.section_type === 'education-special-programs-shell');
    if (!section) {
      section = cmsData.find(s => s.section_type === 'education-special-programs');
    }
    if (!section) return null;
    let published = section.content_published;
    if (typeof published === 'string') {
      try {
        published = JSON.parse(published);
      } catch (e) {
        return null;
      }
    }
    return published?.en || null;
  }, [cmsData]);

  // ── Subjects offered — resolve images ─────────────────────────────────────
  const rawSubjects = Array.isArray(subjectsSection?.subjects) ? subjectsSection.subjects : [];
  
  console.log('[EducationProgramPage] rawSubjects data:', {
    count: rawSubjects?.length || 0,
    firstSubject: rawSubjects?.[0] ? {
      name: rawSubjects[0].name,
      hasPoints: !!rawSubjects[0].points,
      pointsCount: rawSubjects[0].points?.length || 0,
      pointsData: rawSubjects[0].points,
      description: rawSubjects[0].description?.substring(0, 50)
    } : null
  });
  
  const normalizedSubjects = useMemo(
    () =>
      (Array.isArray(rawSubjects) ? rawSubjects : []).map((subject, index) => {
        const subjectName = typeof subject === 'string' ? subject : (subject?.name || `Subject ${index + 1}`);
        
        // CRITICAL FIX: Resolve image ID through mediaMap first, then fall back to hardcoded
        let subjectImage = SUBJECT_IMAGES[subjectName] || FALLBACK_IMAGES[index % FALLBACK_IMAGES.length];
        
        // If subject has an image ID (from CMS), try to resolve it through mediaMap
        if (typeof subject === 'object' && subject?.image) {
          const imageIdStr = String(subject.image); // Ensure string for lookup
          if (mediaMap[imageIdStr]) {
            subjectImage = mediaMap[imageIdStr];
            console.log(`[EducationProgramPage] ✓ Resolved subject image: ${subjectName} -> mediaMap[${imageIdStr}] = ${subjectImage.substring(0, 50)}...`);
          } else {
            console.log(`[EducationProgramPage] ⚠️  Subject image ID not found in mediaMap: ${subjectName} (ID: ${imageIdStr})`);
          }
        }
        
        const normalizedSubject = {
          name: subjectName,
          description: (typeof subject === 'string' ? undefined : subject?.description) || '',
          points: (typeof subject === 'object' && Array.isArray(subject?.points)) ? subject.points : [],
          image: subjectImage,
        };
        
        if (index === 0) {
          console.log('[EducationProgramPage] Normalized first subject:', normalizedSubject);
        }
        
        return normalizedSubject;
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rawSubjects, mediaMap]
  );

  const [activeSubject, setActiveSubject] = useState(normalizedSubjects[0]);

  // ── Learning approach — load from CMS or fallback to defaults ─────────────────────────
  const learningApproachSection = useMemo(() => {
    if (!cmsData || cmsData.length === 0) return null;
    // Try with -shell suffix first, then without
    let section = cmsData.find(s => s.section_type === 'education-learning-approach-shell');
    if (!section) {
      section = cmsData.find(s => s.section_type === 'education-learning-approach');
    }
    if (section) {
      const content = section.content_published || section.content || {};
      return content.en || content;
    }
    return null;
  }, [cmsData]);

  const learningApproach = useMemo(() => {
    const fromCMS = learningApproachSection || EDUCATION_DEFAULTS.learning_approach;
    return {
      title: fromCMS.title || EDUCATION_DEFAULTS.learning_approach.title,
      subtitle: fromCMS.subtitle || EDUCATION_DEFAULTS.learning_approach.subtitle,
      description: fromCMS.description || EDUCATION_DEFAULTS.learning_approach.description,
      pedagogicalModel: fromCMS.pedagogical_model || fromCMS.pedagogicalModel || EDUCATION_DEFAULTS.learning_approach.pedagogicalModel,
      signatureStrategies: (fromCMS.signature_strategies || fromCMS.signatureStrategies || EDUCATION_DEFAULTS.learning_approach.signatureStrategies).map((strategy, idx) => ({
        ...strategy,
        image: strategy.image && mediaMap[strategy.image] ? resolveMediaUrl(mediaMap[strategy.image]) : [epStrategyIBL, epStrategyPBL, epStrategyPrBL][idx] || FALLBACK_IMAGES[idx % FALLBACK_IMAGES.length],
      })),
      integration: fromCMS.integration || EDUCATION_DEFAULTS.learning_approach.integration,
    };
  }, [learningApproachSection, mediaMap]);

  // ── Assessment system ─────────────────────────────────────────────────────
  const rawAssessment = assessmentSection || EDUCATION_DEFAULTS.assessment_system;
  const assessmentSystem = {
    ...rawAssessment,
    points: Array.isArray(rawAssessment?.points) ? (rawAssessment.points || []).map(pt => ({
      ...pt,
      iconType: pt.iconType || pt.icon_type || 'chart',
    })) : [],
  };

  // ── Special programs — resolve images ─────────────────────────────────────
  const rawPrograms = Array.isArray(specialProgramsSection?.programs) ? specialProgramsSection.programs : EDUCATION_DEFAULTS.special_programs.programs;
  const specialPrograms = useMemo(
    () =>
      (Array.isArray(rawPrograms) ? rawPrograms : []).map((item, i) => ({
        ...item,
        image: item.image && mediaMap[item.image] ? resolveMediaUrl(mediaMap[item.image]) : SPECIAL_PROGRAMS_IMAGES[i] || FALLBACK_IMAGES[i % FALLBACK_IMAGES.length],
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rawPrograms, specialProgramsSection, mediaMap]
  );

  useEffect(() => {
    if (!normalizedSubjects.length) {
      return;
    }

    if (!activeSubject) {
      setActiveSubject(normalizedSubjects[0]);
      return;
    }

    const stillExists = normalizedSubjects.some(
      (subject) => subject.name === activeSubject.name
    );

    if (!stillExists) {
      setActiveSubject(normalizedSubjects[0]);
    }
  }, [normalizedSubjects, activeSubject]);

  return (
    <section className="education-program-page">
      <section className="education-hero" id="education-overview">
        <div className="education-hero-media" aria-hidden="true">
          {heroSlides.map((slide, index) => (
            <div
              key={slide}
              className={`education-hero-slide ${index === activeSlide ? 'active' : ''}`}
            >
              <img src={slide} alt="Education program campus" />
            </div>
          ))}
        </div>
        <div className="education-hero-overlay" aria-hidden="true" />
        <div className="education-hero-content">
          <p className="education-hero-kicker">Education Program</p>
          <h2>{heroTitle}</h2>
          <p>{heroSummary}</p>
          <div className="education-hero-dots" role="tablist" aria-label="Education program hero slides">
            {heroSlides.map((slide, index) => (
              <button
                key={slide}
                type="button"
                className={`education-hero-dot ${index === activeSlide ? 'active' : ''}`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Show slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="education-levels" id="program-levels">
        <div className="education-levels-header">
          <p className="education-levels-kicker">Programs</p>
          <h3>Preschool, Kindergarten, Primary, and Secondary</h3>
          <p>
            Each stage is designed to meet students at their level while growing faith, skills, and confidence.
          </p>
        </div>

        <div className="education-levels-grid">
          {displayedLevels.map((level, index) => {
            // If level has external_url or link, redirect to it instead of navigate
            const handleClick = () => {
              const url = level.external_url || level.link;
              if (url) {
                window.open(url, '_blank');
              } else if (onNavigate) {
                onNavigate(level.slug);
              }
            };
            
            return (
            <button
              className="education-level-card edu-animate"
              key={level.title}
              id={level.anchor}
              onClick={handleClick}
              type="button"
              aria-label={`Open ${level.title} details`}
              style={index === 3 ? { opacity: 1, transform: 'none' } : undefined}
            >
              <div className="education-level-media">
                <img src={level.image_url} alt={level.title} />
              </div>
              <div className="education-level-body">
                <div className="education-level-top">
                  <p className="education-level-title">{level.title}</p>
                  <span className="education-level-subtitle">{level.subtitle}</span>
                </div>
                <p className="education-level-description">{level.description}</p>
                <span className="education-level-link">
                  View details
                  <span aria-hidden="true">→</span>
                </span>
              </div>
            </button>
          );
          })}
        </div>
      </section>

      <section className="curriculum-overview" id="curriculum-overview">
        <div className="curriculum-overview-header">
          <p className="curriculum-overview-kicker">Curriculum Overview</p>
          <h3>{curriculumOverview.title}</h3>
          <p>{curriculumOverview.summary}</p>
          <div className="curriculum-overview-pillars">
            {curriculumOverview.pillars.map((pillar) => (
              <div className="curriculum-pillar edu-animate" key={pillar.title}>
                <p className="curriculum-pillar-title">{pillar.title}</p>
                <p>{pillar.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="curriculum-overview-grid">
          {curriculumOverview.tracks.map((item, index) => (
            <article
              className="curriculum-card edu-animate"
              key={item.title}
              style={{ animationDelay: `${index * 120}ms` }}
            >
              <div className="curriculum-card-body">
                <div className="curriculum-card-top">
                  <p className="curriculum-card-kicker">{item.subtitle}</p>
                </div>
                <h4>{item.title}</h4>
                <p className="curriculum-card-description">{item.description}</p>
                <ul className="curriculum-card-list">
                  {item.highlights.map((highlight) => (
                    <li key={highlight}>
                      <span aria-hidden="true">•</span>
                      {highlight}
                    </li>
                  ))}
                </ul>
                {item.components && (
                  <div className="curriculum-components">
                    <p className="curriculum-components-title">Curriculum Structure</p>
                    <div className="curriculum-components-grid">
                      {item.components.map((component) => (
                        <span className="curriculum-component" key={component}>
                          {component}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="curriculum-card-media">
                <img src={item.image} alt={item.title} />
              </div>
            </article>
          ))}
        </div>

        <div className="curriculum-overview-note edu-animate">{curriculumOverview.note}</div>
      </section>

      <section className="subjects-offered" id="subjects-offered">
        <div className="subjects-offered-header">
          <p className="subjects-offered-kicker">{subjectsSection?.title}</p>
          <h3>{subjectsSection?.subtitle}</h3>
          <p>
            {subjectsSection?.description}
          </p>
        </div>
        <div className="subjects-offered-stats edu-animate">
          {subjectsSection?.stats && subjectsSection.stats.length > 0 ? (
            subjectsSection.stats.map((stat, index) => (
              <div className="subjects-stat" key={index}>
                <span className="subjects-stat-value">{stat.value}</span>
                <span className="subjects-stat-label">{stat.label}</span>
              </div>
            ))
          ) : (
            <>
              <div className="subjects-stat">
                <span className="subjects-stat-value">{normalizedSubjects.length}</span>
                <span className="subjects-stat-label">Core Subjects</span>
              </div>
              <div className="subjects-stat">
                <span className="subjects-stat-value">3</span>
                <span className="subjects-stat-label">Learning Domain</span>
              </div>
              <div className="subjects-stat">
                <span className="subjects-stat-value">100%</span>
                <span className="subjects-stat-label">Cambridge + Local Alignment</span>
              </div>
            </>
          )}
        </div>

        <div className="subjects-offered-layout">
          <div className="subjects-offered-list edu-animate">
            {normalizedSubjects.map((subject) => (
              <button
                key={subject.name}
                type="button"
                className={`subject-card ${activeSubject?.name === subject.name ? 'active' : ''}`}
                onClick={() => setActiveSubject(subject)}
              >
                <div>
                  <h4>{subject.name}</h4>
                  <p>{subject.description}</p>
                </div>
                <span className="subject-card-arrow" aria-hidden="true">→</span>
              </button>
            ))}
          </div>

          {activeSubject && (
            <div className="subject-feature edu-animate">
              <div className="subject-feature-header">
                <div>
                  <p className="subject-feature-kicker">Featured Focus</p>
                  <h4>{activeSubject.name}</h4>
                </div>
                <span className="subject-feature-tag">Balanced pathway</span>
              </div>
              <div className="subject-feature-media">
                <img src={activeSubject.image} alt={activeSubject.name} />
              </div>
              <p className="subject-feature-description">{activeSubject.description}</p>
              <ul className="subject-feature-list">
                {(activeSubject.points && Array.isArray(activeSubject.points) && activeSubject.points.length > 0
                  ? activeSubject.points 
                  : []
                ).map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </section>

      <section className="learning-approach" id="learning-approach">
        <div className="learning-approach-header">
          <p className="learning-approach-kicker">Learning Approach</p>
          <h3>5E Model, Inquiry, Project & Problem-Based Learning</h3>
          <p>
            A comprehensive framework that develops curiosity, collaboration, and mastery across every level.
          </p>
        </div>

        {/* 5E Instructional Model */}
        <div className="five-e-model edu-animate">
          <div className="five-e-header">
            <h4>{learningApproach.pedagogicalModel.title}</h4>
            <p className="five-e-subtitle">{learningApproach.pedagogicalModel.subtitle}</p>
            <p className="five-e-description">{learningApproach.pedagogicalModel.description}</p>
          </div>
          <div className="five-e-phases">
            {learningApproach.pedagogicalModel.phases.map((phase, index) => (
              <div className="five-e-phase" key={phase.phase} style={{ animationDelay: `${index * 100}ms` }}>
                <div className="phase-number">{index + 1}</div>
                <div className="phase-icon">
                  {getAssessmentIcon(phase.icon)}
                </div>
                <h5>{phase.phase}</h5>
                <p className="phase-title">{phase.description}</p>
                <p className="phase-details">{phase.details}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Signature Strategies */}
        <div className="signature-strategies edu-animate">
          <div className="strategies-header">
            <h4>Signature Learning Strategies</h4>
            <p>Integrated across all subjects, especially in Humanities, Science, and Global Perspectives</p>
          </div>
          <div className="strategies-grid">
            {learningApproach.signatureStrategies.map((strategy, index) => (
              <article className="strategy-card edu-animate" key={strategy.title} style={{ animationDelay: `${index * 100}ms` }}>
                <div className="strategy-media">
                  <img src={strategy.image} alt={strategy.title} />
                  <div className="strategy-overlay">
                    <div className="strategy-icon">
                      {getAssessmentIcon(strategy.icon)}
                    </div>
                  </div>
                </div>
                <div className="strategy-body">
                  <h5>{strategy.title}</h5>
                  <p className="strategy-description">{strategy.description}</p>
                  <ul className="strategy-outcomes">
                    {strategy.outcomes.map((outcome) => (
                      <li key={outcome}>
                        <span className="outcome-bullet">✓</span>
                        {outcome}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>

        {/* Integration Note */}
        <div className="integration-note edu-animate">
          <div className="note-content">
            <h4>Integrated Learning Across Subjects</h4>
            <p>{learningApproach.integration}</p>
          </div>
        </div>
      </section>

      <section className="assessment-system" id="assessment-system">
        <div className="assessment-system-header">
          <p className="assessment-system-kicker">Assessment System</p>
          <h3>{assessmentSystem.title}</h3>
          <p>{assessmentSystem.summary}</p>
        </div>

        <div className="assessment-system-intro edu-animate">
          <div className="assessment-intro-content">
            <h4>{assessmentSystem.balanced_approach_title}</h4>
            <p>
              {assessmentSystem.balanced_approach_description}
            </p>
          </div>
        </div>

        <div className="assessment-system-grid">
          {assessmentSystem.points.map((item, index) => (
            <article className="assessment-system-card edu-animate" key={item.title} style={{ animationDelay: `${index * 100}ms` }}>
              <div className="assessment-card-header">
                <div className="assessment-card-icon">
                  {getAssessmentIcon(item.iconType)}
                </div>
                <h4>{item.title}</h4>
              </div>
              <p className="assessment-card-description">{item.description}</p>
              <ul className="assessment-card-details">
                {(item.details || []).map((detail) => (
                  <li key={detail}>
                    <span className="detail-bullet">•</span>
                    {detail}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>

        <div className="assessment-methodology edu-animate">
          <div className="methodology-header">
            <h4>{assessmentSystem.assessment_methodology_title}</h4>
            <p>{assessmentSystem.assessment_methodology_subtitle}</p>
          </div>
          <div className="methodology-grid">
            {assessmentSystem.methodology.map((item, index) => (
              <div className="methodology-card" key={item.phase} style={{ animationDelay: `${index * 100}ms` }}>
                <div className="methodology-number">{index + 1}</div>
                <h5>{item.phase}</h5>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="assessment-benefits edu-animate">
          <div className="benefits-header">
            <h4>What This Means for Your Child</h4>
          </div>
          <div className="benefits-grid">
            {Array.isArray(assessmentSystem.what_this_means) && assessmentSystem.what_this_means.map((item, index) => (
              <div className="benefit-item" key={item.title}>
                <div className="benefit-icon">
                  {[AssessmentIcons.book, AssessmentIcons.chart, AssessmentIcons.users, AssessmentIcons.zap][index % 4]}
                </div>
                <h5>{item.title}</h5>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="assessment-timeline edu-animate">
          <div className="timeline-header">
            <h4>{assessmentSystem.assessment_calendar_header_title}</h4>
            <p>{assessmentSystem.assessment_calendar_header_subtitle}</p>
          </div>
          <div className="timeline-cards">
            {Array.isArray(assessmentSystem.assessment_calendar) && assessmentSystem.assessment_calendar.map((item, index) => {
              // First activity is the title, rest are description
              const activities = Array.isArray(item.activities) ? item.activities : [];
              const activityTitle = activities[0] || item.title || item.period;
              const activityDescriptions = activities.slice(1);
              
              return (
              <div className="timeline-card" key={item.period}>
                <div className="timeline-card-header">
                  <div className="timeline-card-icon">
                    {[AssessmentIcons.calendar, AssessmentIcons.clipboard, AssessmentIcons.chart, AssessmentIcons.trending, AssessmentIcons.award][index % 5]}
                  </div>
                  <div className="timeline-card-period">{item.period}</div>
                </div>
                <h5>{activityTitle}</h5>
                {activityDescriptions.map((desc, descIdx) => (
                  <p key={descIdx} style={{ margin: '0.5rem 0 0 0' }}>{desc}</p>
                ))}
              </div>
            );
            })}
          </div>
        </div>

        <div className="assessment-cta edu-animate">
          <div className="cta-content">
            <h4>Questions About Assessment?</h4>
            <p>We're happy to discuss how we evaluate student progress and support your child's learning journey.</p>
            <button
              className="assessment-cta-button"
              type="button"
              onClick={() => onNavigate && onNavigate('contact-us', 'contact-form')}
            >
              Schedule a Conversation
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </section>

      <section className="special-programs" id="special-programs">
        <div className="special-programs-header">
          <p className="special-programs-kicker">{specialProgramsSection?.title || EDUCATION_DEFAULTS.special_programs.title}</p>
          <h3>{specialProgramsSection?.subtitle || EDUCATION_DEFAULTS.special_programs.subtitle}</h3>
          <p>
            {specialProgramsSection?.description || EDUCATION_DEFAULTS.special_programs.description}
          </p>
          <div className="special-programs-actions">
            <p className="special-programs-note">
              Full schedules and program details are available in Student Life.
            </p>
            <a
              href="#student-life"
              className="special-programs-link"
              onClick={(e) => {
                e.preventDefault();
                onNavigate && onNavigate('student-life', 'programs');
              }}
            >
              View Student Life Programs
              <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>

        <div className="special-programs-stats edu-animate">
          {(specialProgramsSection?.stats || EDUCATION_DEFAULTS.special_programs.stats).map((stat, index) => (
            <div className="special-programs-stat" key={index}>
              <span className="special-programs-stat-value">{stat.value}</span>
              <span className="special-programs-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>

        <div className="special-programs-grid">
          {specialPrograms.map((item) => (
            <article className="special-programs-card edu-animate" key={item.title}>
              <div className="special-programs-media">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="special-programs-body">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  );
}

export default EducationProgramPage;
